// extracted by mini-css-extract-plugin
export var cdCountdown = "countdown-module--cd-countdown--8acbf";